export const SAME_ATTR_RELATIVE_FILTER = { type: 'same-attribute', displayName: 'Same Attribute' };

export const RELATIVE_FILTERS = [
  { type: 'self', displayName: 'Self' },
  { type: 'direct-reports', displayName: 'Direct Reports' },
  { type: 'all-reports', displayName: 'Direct and Indirect Reports' },
  SAME_ATTR_RELATIVE_FILTER,
];

export const RELATIVE_FILTERS_NAME_LOOKUP = Object.fromEntries(
  RELATIVE_FILTERS.map(filter => [filter.type, filter.displayName]),
);

export const ATTR_TYPE_TEXT = 'text';
export const ATTR_TYPE_TEXT_COLLECTION = 'textCollection';
export const ATTR_TYPE_DATE = 'date';
export const ATTR_TYPE_NUMBER = 'number';
export const ATTR_TYPE_BOOLEAN = 'boolean';
export const VALID_FIELD_TYPES = ['date', 'number', 'text', 'boolean'];
export const COMPARISON_TYPE_RELATIVE = 'relative';

export const DEFAULT_COMPARISONS = ['eq', 'neq', 'hav', 'ukn'];

export const TEXT_COMPARISONS = [...DEFAULT_COMPARISONS, 'ct', 'nct'];
export const TEXT_COLLECTION_COMPARISONS = [...DEFAULT_COMPARISONS];
export const DATE_COMPARISONS = [...DEFAULT_COMPARISONS, 'lt', 'gt'];
export const NUMBER_COMPARISONS = [...DEFAULT_COMPARISONS, 'lt', 'gt'];
export const BOOLEAN_COMPARISONS = [...DEFAULT_COMPARISONS];

export const ROLES_TABLE_ROWS_PER_PAGE_OPTIONS = [30, 50, 100];

export const PERMISSION_ITEMS = [
  { id: 'edit-profile', name: 'Edit Profile' },
  { id: 'view-person', name: 'View Person/Profile' },
  { id: 'view-restricted-attributes', name: 'View Restricted Attributes for Person' },
];

export const CONTENT_TYPE_FIELD = 'field';
export const CONTENT_TYPE_FIELD_FOR_SAME_ATTR = 'fieldForSameAttr';
export const CONTENT_TYPE_COMPARISON = 'comparison';
export const CONTENT_TYPE_VALUE = 'value';

export const VALUE_INPUT_TYPE_TEXT = 'text';
export const VALUE_INPUT_TYPE_DATE = 'date';
export const VALUE_INPUT_TYPE_BOOLEAN = 'boolean';
export const VALUE_INPUT_TYPE_TEXT_AND_SEARCH = 'textAndSearch';

export const BACKDROP_Z_INDEX = 1200;
export const MATCH_ALL_FILTER = { matchAll: true };
export const TOTAL_NUM_OF_AVAILABLE_PERMISSIONS = 3;
